import axios, { AxiosError } from 'axios';
import type { ApiResponse } from '../types/api';
import { getDeviceId } from '../utils/deviceId';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 매장 어드민 인증: 로그인 시 받은 licenseKey 를 모든 요청에 x-license-key 헤더로 부착한다.
// AuthContext 가 로그인/세션복원/로그아웃 시 setAuthLicenseKey() 로 갱신한다.
// (데모 세션은 licenseKey 를 localStorage 가 아닌 메모리에만 두므로 모듈 변수 방식 사용)
let authLicenseKey: string | null = null;

export function setAuthLicenseKey(key: string | null): void {
  authLicenseKey = key;
}

client.interceptors.request.use((config) => {
  if (authLicenseKey) {
    config.headers.set('x-license-key', authLicenseKey);
  }
  config.headers.set('x-device-id', getDeviceId());
  return config;
});

client.interceptors.response.use(
  (response) => {
    const body = response.data as ApiResponse<unknown>;

    if (body.success === false) {
      const error = new Error(body.error || '요청에 실패했습니다.');
      return Promise.reject(error);
    }

    // data 필드를 추출하여 반환
    response.data = body.data;
    return response;
  },
  (error: AxiosError<ApiResponse<unknown>>) => {
    if (error.response?.data?.error) {
      return Promise.reject(new Error(error.response.data.error));
    }
    return Promise.reject(error);
  },
);

export default client;
